import { render } from "./RestorantMarker.vue?vue&type=template&id=5ea504ee&ts=true"
import script from "./RestorantMarker.vue?vue&type=script&lang=ts"
export * from "./RestorantMarker.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__